import { createContext } from '@lit/context';
import { Messages } from '../../@types/wishlist.js';

export const i18nContext = createContext<Messages>('i18nContext');
